'use client';

const imageLoader = ({ src, width, height, quality }) => {
  const splitted = src.split('?');
  const cfit = splitted[0].includes('/cfit/');
  const params = new URLSearchParams(splitted?.[1] || '');
  if (width && (cfit ? !params.get('w') : true)) params.set('w', width.toString());
  if (height && (cfit ? !params.get('h') : true)) params.set('h', height.toString());
  if (quality && (cfit ? !params.get('q') : true))
    params.set('q', quality ? quality.toString() : '75');

  return `${splitted[0]}?${params.toString()}`;
};

export default imageLoader;
